import { Button, Col, Container, Row, Table, Form, Pagination } from "react-bootstrap"
import React, { useMemo, useState, useRef } from "react"
import { Link, useNavigate } from "react-router-dom"
import { DELETE_SUBSCRIPTION } from "../../constant/Constants"
import { DSMDelete } from "../../api/AuthService"

function DynamicSubResults(props) {
   const navigate = useNavigate()
   const useSortableData = (items, config = null) => {
      const [sortConfig, setSortConfig] = useState(config)
      const sortedItems = useMemo(() => {
         let sortableItems = [...items]
         if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
               if (sortConfig.key === "Create Date") {
                  if (new Date(a[sortConfig.key]) < new Date(b[sortConfig.key])) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (new Date(a[sortConfig.key]) > new Date(b[sortConfig.key])) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  return 0
               } else {
                  if (a[sortConfig.key] < b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (a[sortConfig.key] > b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  return 0
               }
            })
         }
         return sortableItems
      }, [items, sortConfig])

      const requestSort = (key) => {
         let direction = "ascending"
         if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === "ascending"
         ) {
            direction = "descending"
         }
         setSortConfig({ key, direction })
      }
      return { items: sortedItems, requestSort, sortConfig }
   }

   const [resultsPerPage, setResultsPerPage] = useState(30)
   const [currentPage, setCurrentPage] = useState(1)
   const indexOfLastResult = currentPage * resultsPerPage
   const indexOfFirstResult = indexOfLastResult - resultsPerPage
   const { items, requestSort, sortConfig } = useSortableData(props.results)
   const currentResult = items.slice(indexOfFirstResult, indexOfLastResult)
   const[isAlertvisible,setIsAlertVisible]=React.useState(false);
   const [activePage, setActivePage] = useState(1)

   const selectedcurrentResult = useRef([])

   const handleSelectAllChange = () => {
      const selectAllStatus =
         selectedcurrentResult.current.length !== props.results.length

      if (selectAllStatus) {
         selectedcurrentResult.current = props.results.map((employee) => employee.id)
      } else {
         selectedcurrentResult.current = []
      }

      setForceUpdate((prevState) => !prevState)
   }

   const handleCheckboxChange = (userId) => {
      const index = selectedcurrentResult.current.indexOf(userId)

      if (index === -1) {
         selectedcurrentResult.current.push(userId)
      } else {
         selectedcurrentResult.current.splice(index, 1)
      }

      setForceUpdate((prevState) => !prevState)
   }

   const selectAll = selectedcurrentResult.current.length === props.results.length
   const isSendButtonDisabled = selectedcurrentResult.current.length === 0
   const [forceUpdate, setForceUpdate] = useState(false)
   let deleteForm;
   function show(){
      setIsAlertVisible(true);
      setTimeout(()=>{
         setIsAlertVisible(false);
      },4000)
   }

   const sendCurrentResultIDs = () => {
      deleteForm = window.confirm(
         "Do you want to delete the selected Subscription(s)?"
      )

      if (deleteForm) {
         const selectedIds = selectedcurrentResult.current

         DSMDelete(`${DELETE_SUBSCRIPTION}`, { objectId: selectedIds })
            .then((response) => {
              
            })
            .catch((error) => {
               console.error("API errr", error)
            })
         show()
      }
   }
  

   const getClassNamesFor = (name) => {
      if (!sortConfig) {
         return "fa fa-sort"
      } else if (sortConfig.key === name) {
         if (sortConfig.direction === "ascending") {
            return "fa fa-caret-up"
         } else {
            return "fa fa-caret-down"
         }
      } else {
         return "fa fa-sort"
      }
   }
   const subscriptionInfo = currentResult.map((key, index) => (
      <tr key={key.id}>
         <td align="center" width="5%">
            {" "}
            <Form.Check
               type={props.type !== "organization" ? "checkbox" : "radio"}
               onChange={() => handleCheckboxChange(key.id)}
               checked={selectedcurrentResult.current.includes(key.id)}
            />
         </td>
         <td align="left" width="10%">
            <Link to={`/SubscriptionDetails/${key.id}`}>
               <span textalign="left">{key["Product Data Type"]}</span>
            </Link>
         </td>
         <td align="left" width="5%">
            {key["State"]}
         </td>
         <td align="left" width="10%">
            {key["Policy"]}
         </td>
         <td align="left" width="10%">
            {key["Organization"]}
         </td>
         <td align="left" width="10%">
            {key["Vendor"]}
         </td>
         <td align="left" width="10%">
            {key["Subscription Frequency"]}
         </td>
         <td align="left" width="5%">
            {key["Plant"]}
         </td>
         <td align="left" width="5%">
            {key["Brand"]}
         </td>
         <td align="left" width="5%">
            {key["Segment"]}
         </td>
         <td align="left" width="10%">
            {key["Manufacturing Status"]}
         </td>
         <td align="left" width="10%">
            {key["Expiration Date"]}
         </td>
         <td align="left" width="10%">
            {key["Owner"]}
         </td>
         <td align="left" width="10%">
            {key["GCAS"]}
         </td>
      </tr>
   ))
   function handlePageChange(pageNumber) {
      setCurrentPage(pageNumber)
      setActivePage(pageNumber)
   }
   const handleRefresh=()=>{
      props.refreshHandler()
      window.location.reload();
   }

   const totalPages = Math.ceil(props.results.length / resultsPerPage)

   const renderPaginationItems = () => {
      const items = []
      const maxPagesToShow = 6
      let startPage = Math.max(1, activePage - Math.floor(maxPagesToShow / 2))
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

      if (endPage - startPage + 1 < maxPagesToShow) {
         startPage = Math.max(1, endPage - maxPagesToShow + 1)
      }

      if (activePage > 1) {
         items.push(
            <Pagination.First key="first" onClick={() => handlePageChange(1)} />,
            <Pagination.Prev key="prev" onClick={() => handlePageChange(activePage - 1)} />
         )
      }

      for (let page = startPage; page <= endPage; page++) {
         items.push(
            <Pagination.Item
               key={page}
               active={page === activePage}
               onClick={() => handlePageChange(page)}
            >
               {page}
            </Pagination.Item>
         )
      }

      if (activePage < totalPages) {
         items.push(
            <Pagination.Next key="next" onClick={() => handlePageChange(activePage + 1)} />,
            <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
         )
      }

      return items
   }

   return (
      <React.Fragment>
         <React.Fragment>
         {isAlertvisible && <Row>
            <Col md="11" sm="11" align="center">
               <p  id="msg"className="successMsg" style={{ marginTop: "4px", fontWeight: "bold" }} >
               Your Subscription(s) deletion request will be processed in the background and will complete shortly. Please refresh the screen after few minutes
               </p>
            </Col>
         </Row>} 
            <Row
               className="mb-3"
               style={{ marginBottom: "10px", paddingLeft: "15px", paddingRight: "15px" }}
            >
               <Col md={10} sm={7} align="left">
                  <Button
                     variant="primary"
                     onClick={() => navigate("/DynamicSubscription")}
                  >
                     Create
                  </Button>

                  <Button
                     variant="primary"
                     onClick={sendCurrentResultIDs}
                     style={{ border: "none", marginLeft: "5px" }}
                     disabled={isSendButtonDisabled}
                     className={isSendButtonDisabled ? "disabled" : ""}
                  >
                     Delete
                  </Button>

                  <Button
                     variant="primary"
                     onClick={handleRefresh}
                     style={{ border: "none", marginLeft: "5px" }}
                  >
                     Refresh
                  </Button>
               </Col>
               <Col className="pageinationSub" align="right">
                  <div style={{ width: "40%", verticalAlign: "middle" }} id="paginTab">
                     {props.error === 0 && (
                        <Pagination>{renderPaginationItems()}</Pagination>
                     )}
                  </div>
               </Col>
            </Row>
            {props.loading ? (
               <h2 style={{ textAlign: "center", color: "#0173d4" }}>
                  <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }} />
                  Loading........
               </h2>
            ) : (
               <div className="searchScrollbar">
                  <Table bordered className="bordered-table">
                     <thead id="template_summ_tab">
                        <tr>
                           {props.error === 0 && props.type !== "organization" ? (
                              <th width="5%">
                                 <Form.Check
                                    type="checkbox"
                                    style={{ textAlign: "center" }}
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                 />
                              </th>
                           ) : (
                              <th width="3%" style={{ paddingRight: "10px" }}>
                                 <Form.Check
                                    type="checkbox"
                                    style={{ textAlign: "center" }}
                                    disabled
                                 />
                              </th>
                           )}
                           <th width="10%">
                              Product Data Type&nbsp;
                              <i
                                 onClick={() => requestSort("Product Data Type")}
                                 className={getClassNamesFor("Product Data Type")}
                              ></i>
                           </th>
                           <th width="5%">State</th>
                           <th width="10%">Policy</th>
                           <th width="10%">Organization</th>
                           <th width="10%">Vendor</th>
                           <th width="10%">Subscription Frequency </th>
                           <th width="5%">Plant </th>
                           <th width="5%">Brand </th>
                           <th width="5%">Segment </th>
                           <th width="10%">Manufacturing Status </th>
                           <th width="10%">Expiration Date </th>
                           <th width="10%">Owner </th>
                           <th width="10%">GCAS Name </th>
                        </tr>
                     </thead>
                     {props.error === 0 && <tbody>{subscriptionInfo}</tbody>}
                     {props.error === 1 && (
                        <tbody>
                           <tr>
                              <td
                                 colSpan="14"
                                 style={{
                                    textAlign: "center",
                                    color: "#0173d4",
                                    fontSize: "18px",
                                 }}
                              >
                                 No Records Found.
                              </td>
                           </tr>
                        </tbody>
                     )}
                     {props.error === 2 && (
                        <tbody>
                           <tr>
                              <td
                                 colSpan="14"
                                 style={{
                                    textAlign: "center",
                                    color: "#0173d4",
                                    fontSize: "18px",
                                 }}
                              >
                                Dynamic Subscription service issue. Please contact SpecReaderExt.im@pg.com for help.
                              </td>
                           </tr>
                        </tbody>
                     )}
                  </Table>
               </div>
            )}
         </React.Fragment>
      </React.Fragment>
   )
}
export default DynamicSubResults